import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  branch: { name: '', referenceNumber: [], description: '' },
  seenStampData: [],
  isFetching: false,
  isSuccess: false,
  isResponse: false,
  isBrResponse: false,
  brName: null,
  isError: false,
  errorMessage: '',
};

export const viewEditBranchAsyn = createAsyncThunk(
  'department/viewEditBranch',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const options = {
        params: udata,
        headers: { "Authorization": `Bearer ${tokenStr}` }
      };

      const response = await axios.get('/api/detailedDepartment/deptType/', options, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      //   let response = await axios({
      //     url: '/api/detailedDepartment/deptType/',
      //     method: 'get',
      //     data:udata,
      //     //timeout: 8000,
      //     headers: {
      //         //'Content-Type': 'application/json',
      //         "Authorization" : `Bearer ${tokenStr}`
      //     }
      // })

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const viewEditBranchSlice = createSlice({
  name: 'vieweditbranch',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateSlice: (state, { payload }) => {
      state.branch = [];
      state.isError = false;
      state.isSuccess = false;
      state.isResponse = false;
      state.errorMessage = '';
    },
    setBrResponseState: (state, { payload }) => {
      state.isBrResponse = true;
      state.brName = payload;
    },
    unBrSetResponseState: (state, { payload }) => {
      state.isBrResponse = false;
      state.brName = null;
    },
    setResponseState: (state, { payload }) => {
      state.isResponse = true;
    },
    unSetResponseState: (state, { payload }) => {
      state.isResponse = false;
    },
    setSeenStampNames: (state, { payload }) => {
      state.seenStampData = payload.data.templates;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [viewEditBranchAsyn.fulfilled]: (state, { payload }) => {
      state.branch = payload.data;
      state.isFetching = false;
      state.isSuccess = true;
      state.errorMessage = payload.message;
      return state;
    },
    [viewEditBranchAsyn.pending]: (state) => {
      state.isFetching = true;
    },
    [viewEditBranchAsyn.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateSlice, setSeenStampNames, setResponseState, unSetResponseState, setBrResponseState, unBrSetResponseState } = viewEditBranchSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateSlice());
  }
}

export function responseState() {

  return async (dispatch) => {
    dispatch(setResponseState());
  }
}

export function clearResponseState() {

  return async (dispatch) => {
    dispatch(unSetResponseState());
  }
}

export function responseBrState(br) {

  return async (dispatch) => {
    dispatch(setBrResponseState(br));
  }
}

export function clearBrResponseState() {

  return async (dispatch) => {
    dispatch(unBrSetResponseState());
  }
}

export const viewEditBranchSelector = (state) => state.vieweditbranch;

export const oldupdateBranchAsyn = (bdata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  const response = await axios.patch('/api/department', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

  //    let response = await axios({
  //      url: '/api/department',
  //      method: 'post',
  //      //timeout: 8000,
  //      headers: {
  //          //'Content-Type': 'application/json',
  //          "Authorization" : `Bearer ${tokenStr}`
  //      }
  //  })

  let data = response.data;
  return data;
  //console.log(data.data)
  //dispatch(getAllIOS(data));
};

export const updateBranchAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/department', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateDrStatusAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/department/type/activeStatus', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};


export const addDrAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/department/addDeptType', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const editBrAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/department/referenceNumber', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateBrOnlyAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/department', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};



export const getSeenStampForAdminAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.get('/api/template?limit=1000000&page=1', { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    dispatch(setSeenStampNames(data));
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateSeenStampForAdminAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/department/template', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export default viewEditBranchSlice.reducer;
